import client from './client';
import { 
  ApiResponse, 
  AdminUserSummaryResponse,
  UserResponse, 
  UserStatus, 
  GlobalRole,
  ApprovalStatus
} from '../types';

export const userApi = {
  getUsers: () => 
    client.get<ApiResponse<UserResponse[]>>('/api/v1/admin/users'),

  getUsersSummary: () =>
    client.get<ApiResponse<AdminUserSummaryResponse>>('/api/v1/admin/users/summary'),
    
  getUser: (userId: number) => 
    client.get<ApiResponse<UserResponse>>(`/api/v1/admin/users/${userId}`),
    
  createUser: (data: { email: string; password: string; name: string; globalRole: GlobalRole }) => 
    client.post<ApiResponse<UserResponse>>('/api/v1/admin/users', data),
    
  updateUser: (userId: number, data: { status?: UserStatus; name?: string }) => 
    client.patch<ApiResponse<UserResponse>>(`/api/v1/admin/users/${userId}`, data),
    
  updateGlobalRole: (userId: number, data: { globalRole: GlobalRole }) => 
    client.patch<ApiResponse<UserResponse>>(`/api/v1/admin/users/${userId}/global-role`, data),

  updateApproval: (userId: number, data: { approvalStatus: ApprovalStatus }) =>
    client.patch<ApiResponse<UserResponse>>(`/api/v1/admin/users/${userId}/approval`, data),

  updateAdRemovalTicket: (userId: number, data: { purchased: boolean }) =>
    client.patch<ApiResponse<UserResponse>>(`/api/v1/admin/users/${userId}/ad-removal-ticket`, data),
};
